import { Box } from "@mui/material";
import styles from "../StructuredPromptImageCanvas.module.scss";

interface ObjectDotProps {
	x: number;
	y: number;
	onMouseEnter: () => void;
	onClick?: (e: React.MouseEvent) => void;
	onMouseDown?: (e: React.MouseEvent) => void;
}

export const ObjectDot = ({ x, y, onMouseEnter, onClick, onMouseDown }: ObjectDotProps) => {
	return (
		<Box
			data-object-dot
			className={styles.dot}
			style={{
				left: `${x}px`,
				top: `${y}px`,
				transform: "translate(-50%, -50%)",
			}}
			onMouseEnter={onMouseEnter}
			onClick={onClick}
			onMouseDown={onMouseDown}
		/>
	);
};
